import { useCallback } from 'react';
import {
  getProject,
  useUpdateProject,
} from '@client/store/project/project.hook';
import { updateProjectMetadata } from '@shared/helpers/project.helpers';
import { detachScopePreset, getScope } from './scope.store';

/**
 * Write the project's calculation period (`building_lifetime`).
 *
 * The period lives on the project rather than in the scope, so a preset that pins
 * one stops describing the scope as soon as that period is changed by hand — the
 * scope detaches to custom. Presets without a period (the A1–A5 ones, where the
 * period does not affect results) are left alone, as is a write that matches the
 * active preset's own period.
 */
export const useSetCalculationPeriod = (): ((years: number) => void) => {
  const updateProject = useUpdateProject();
  return useCallback(
    (years: number) => {
      const { preset } = getScope();
      const pinned = preset?.calculationPeriodYears;
      if (pinned !== undefined && pinned !== years) detachScopePreset();
      // TODO(replay): express as ProjectChange so a 422 race can be replayed.
      void updateProject({
        kind: 'snapshot',
        project: updateProjectMetadata(getProject(), {
          building_lifetime: years,
        }),
      });
    },
    [updateProject],
  );
};
